import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer/Footer';
import { colors } from '../../tailwind';
import Logo from '../Logo/Logo';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { isSmall } = this.props;
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: colors.background,
          fontFamily: 'Metropolis',
        }}
      >
        {isSmall && <Logo />}
        {!isSmall && <Header />}
        <div style={{ flexGrow: 1, display: 'flex' }}>
          {this.props.children}
        </div>
        {!isSmall && <Footer />}
      </div>
    );
  }
}

export default withStyles(s)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js